import React, { useState } from "react";
import { useNavigate } from "react-router";
import uuid from "react-uuid";
import {
  CTAButtons,
  CTAButtonsAlt,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import PageStyle from "../../../Components/Layout/PageLayout";
import { formEl } from "../../../constants";
import {
  CheckboxInput,
  RadioInput,
  RatingScale,
  TextArea,
  TextFieldInput,
} from "./elements";
import input from "./input.module.css";
import { CustomSorter } from "../../../Components/CustomSorter/CustomSorter";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { useCreateSurveyMutation } from "../../../../api/financeApi";
import { toast } from "react-toastify";

const CreateSurvey = () => {
  const initVal = formEl[0]?.value;
  const buildRatingOptions = (min = 1, max = 5) => {
    const options = [];
    for (let i = min; i <= max; i++) {
      options.push({ id: uuid(), value: i.toString() });
    }
    return options;
  };
  const [data, setData] = useState([
    {
      id: uuid(),
      value: null,
      type: "text",
      required: false,
    },
  ]);
  const [showPreview, setShowPreview] = useState(false);
  const [formData, setFormData] = useState("text");
  const [purpose, setPurpose] = useState(1);
  const [createSurvey, { isLoading }] = useCreateSurveyMutation();
  const addElement = () => {
    const newData = {
      id: uuid(),
      value: null,
      type: formData,
      required: false,
      ...(formData === "rating" && { min: 1, max: 5 }),
    };
    if (formData === "rating") {
      newData.options = [];
      for (let i = 1; i <= 5; i++) {
        newData.options.push({ id: uuid(), value: i.toString() });
      }
    }
    setData((prevState) => [...prevState, newData]);
    setFormData(initVal);
  };

  const deleteEl = (id) => {
    setData((prevState) => prevState.filter((val) => val.id !== id));
  };

  const addAfter = (elArray, index, newEl) => {
    return [...elArray.slice(0, index + 1), newEl, ...elArray.slice(index + 1)];
  };

  const duplicateElement = (elId, elType) => {
    let elIdx = data.findIndex((el) => el.id === elId);
    let originalEl = data[elIdx];
    let newEl = {
      id: uuid(),
      value: null,
      type: elType,
      required: false,
      ...(elType === "rating" && {
        min: originalEl.min || 1,
        max: originalEl.max || 5,
      }),
    };
    if (elType === "rating") {
      newEl.options = [];
      for (let i = originalEl.min || 1; i <= (originalEl.max || 5); i++) {
        newEl.options.push({ id: uuid(), value: i.toString() });
      }
    }
    let newArr = addAfter(data, elIdx, newEl);
    setData(newArr);
  };

  const handleOnChangeSort = ({ items }) => {
    setData(items);
  };

  const handleValue = (id, e) => {
    let newArr = data.map((el) => {
      if (el.id == id) {
        return { ...el, value: e.target.value };
      } else {
        return el;
      }
    });
    setData(newArr);
  };

  const handleRequired = (id) => {
    let newArr = data.map((el) => {
      if (el.id == id) {
        return { ...el, required: !el.required };
      } else {
        return el;
      }
    });
    setData(newArr);
  };

  const handleElType = (id, type) => {
    let newArr = data.map((el) => {
      if (el.id == id) {
        if (type === "rating") {
          const min = el.min || 1;
          const max = el.max || 5;
          return {
            ...el,
            type,
            min,
            max,
            options:
              el.options && el.options.length > 0
                ? el.options
                : buildRatingOptions(min, max),
          };
        }
        return { ...el, type: type };
      } else {
        return el;
      }
    });
    setData(newArr);
  };

  const handleMinMax = (id, min, max) => {
    let newArr = data.map((el) => {
      if (el.id == id) {
        const newOptions = [];
        for (let i = min; i <= max; i++) {
          newOptions.push({ id: uuid(), value: i.toString() });
        }
        return { ...el, min, max, options: newOptions };
      } else {
        return el;
      }
    });
    setData(newArr);
  };

  const addOption = (id, newOption) => {
    let newArr = data.map((el) => {
      if (el.id == id) {
        const objVal = "options" in el ? el?.options : [];
        return { ...el, options: [...objVal, newOption] };
      } else {
        return el;
      }
    });
    setData(newArr);
  };

  const handleOptionValues = (elId, optionId, optionVal) => {
    let newArr = data.map((el) => {
      if (el.id == elId) {
        el?.options &&
          el?.options.map((opt) => {
            if (opt.id == optionId) {
              opt.value = optionVal;
            }
          });
        return el;
      } else {
        return el;
      }
    });
    setData(newArr);
  };

  const deleteOption = (elId, optionId) => {
    let newArr = data.map((el) => {
      if (el.id == elId) {
        let newOptions =
          el?.options && el?.options.filter((opt) => opt.id != optionId);
        return { ...el, options: newOptions };
      } else {
        return el;
      }
    });
    setData(newArr);
  };

  const renderElements = ({ item, index }) => {
    switch (item.type) {
      case "text":
        return (
          <TextFieldInput
            item={item}
            handleValue={handleValue}
            deleteEl={deleteEl}
            handleRequired={handleRequired}
            handleElType={handleElType}
            duplicateElement={duplicateElement}
            disableDelete={index < 1}
            isPreview={showPreview}
          />
        );
      case "textarea":
        return (
          <TextArea
            item={item}
            handleValue={handleValue}
            deleteEl={deleteEl}
            handleRequired={handleRequired}
            handleElType={handleElType}
            duplicateElement={duplicateElement}
            disableDelete={index < 1}
            isPreview={showPreview}
          />
        );

      case "radio":
        return (
          <RadioInput
            item={item}
            handleValue={handleValue}
            deleteEl={deleteEl}
            handleRequired={handleRequired}
            handleElType={handleElType}
            addOption={addOption}
            handleOptionValues={handleOptionValues}
            deleteOption={deleteOption}
            duplicateElement={duplicateElement}
            disableDelete={index < 1}
            isPreview={showPreview}
          />
        );
      case "checkbox":
        return (
          <CheckboxInput
            item={item}
            handleValue={handleValue}
            deleteEl={deleteEl}
            handleRequired={handleRequired}
            handleElType={handleElType}
            addOption={addOption}
            handleOptionValues={handleOptionValues}
            deleteOption={deleteOption}
            duplicateElement={duplicateElement}
            disableDelete={index < 1}
            isPreview={showPreview}
          />
        );
      case "rating":
        return (
          <RatingScale
            item={item}
            handleValue={handleValue}
            deleteEl={deleteEl}
            handleRequired={handleRequired}
            handleElType={handleElType}
            addOption={addOption}
            handleOptionValues={handleOptionValues}
            deleteOption={deleteOption}
            duplicateElement={duplicateElement}
            handleMinMax={handleMinMax}
            disableDelete={index < 1}
            isPreview={showPreview}
          />
        );
      default:
        return (
          <TextFieldInput
            item={item}
            handleValue={handleValue}
            deleteEl={deleteEl}
            handleRequired={handleRequired}
            handleElType={handleElType}
            duplicateElement={duplicateElement}
            disableDelete={index < 1}
            isPreview={showPreview}
          />
        );
    }
  };
  const purposes = [
    { label: "Business Development", value: 1 },
    { label: "Relationship Management", value: 2 },
  ];
  const navigate = useNavigate();
  const itemType = (type) => {
    switch (type) {
      case "text":
        return 4;
      case "textarea":
        return 5;
      case "radio":
        return 2;
      case "checkbox":
        return 1;
      case "rating":
        return 3;
      default:
        return 4;
    }
  };
  const handleSubmit = async () => {
    try {
      const hasRatingQuestion = data.some((item) => item.type === "rating");
      if (!hasRatingQuestion) {
        toast.error("At least one rating scale question is required.");
        return;
      }

      const surveyData = {
        categoryType: parseInt(purpose),
        surveyInformation: data.map((item, index) => ({
          questionText: item.value,
          questionType: itemType(item.type),
          isRequired: item.required,
          displayOrder: index + 1,
          characterLimit: item.type === "textarea" ? 255 : 200,
          ratingScaleMin: item.type === "rating" ? item.min : 0,
          ratingScaleMax: item.type === "rating" ? item.max : 0,
          options: item.options?.map((opt) => opt.value) || [],
        })),
      };

      const response = await createSurvey(surveyData).unwrap();
      if (response?.successful) {
        navigate(-1);
        toast.success(response?.statusMessage);
      }
    } catch (error) {
      toast.error(error?.data?.validationErrors?.[0]);
    }
  };
  const handlePreview = () => {
    setShowPreview(true);
  };
  const handleHidePreview = () => {
    setShowPreview(false);
  };
  const hasRatingQuestion = data.some((item) => item.type === "rating");

  const actionButton = (
    <div className="flex space-x-3 items-center">
      <SupportButtons onClick={() => navigate(-1)}>Cancel</SupportButtons>
      <SupportButtons onClick={showPreview ? handleHidePreview : handlePreview}>
        {showPreview ? "Back to Edit" : "Preview"}
      </SupportButtons>
      <CTAButtons
        disabled={!hasRatingQuestion || isLoading}
        onClick={handleSubmit}
        type="submit"
      >
        {isLoading ? "Submitting..." : "New Request"}
      </CTAButtons>
    </div>
  );

  return (
    <RouteLayout navHidden={true}>
      <PageStyle
        hasBack={true}
        backURL={`/dashboard/finance/feedback-survey`}
        demoTitle={"New Feedback Survey"}
        hasTopPageDemo
        action={actionButton}
      >
        <div className="space-y-6">
          <div className="bg-white p-6 flex items-start justify-between rounded-lg shadow">
            <div className="w-1/2">
              <h3 className="text-lg font-semibold mb-4">Basic Information</h3>
            </div>
            <div className={`${input.input_container} w-1/2`}>
              <label className={input.input_title}>Category *</label>
              <select
                value={purpose}
                onChange={(e) => setPurpose(e.target.value)}
                className={input.input_field}
                disabled={showPreview}
              >
                {purposes.map((p) => (
                  <option key={p.value} value={p.value}>
                    {p.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-semibold mb-4">Request Information</h3>
            <div className="flex flex-col justify-center items-center">
              <div className=" w-full max-w-2xl gap-4">
                <div className="w-full ">
                  {showPreview ? (
                    data.map((item, index) => (
                      <div key={item.id}>{renderElements({ item, index })}</div>
                    ))
                  ) : (
                    <CustomSorter
                      items={data}
                      setItems={setData}
                      renderItem={(item, index) => renderElements({ item, index })}
                      keyExtractor={(item) => item.id}
                    />
                  )}
                </div>
                {!showPreview && (
                  <div className="flex justify-end">
                    <CTAButtonsAlt onClick={addElement} type="submit">
                      Add More Questions
                    </CTAButtonsAlt>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </PageStyle>
    </RouteLayout>
  );
};

export default CreateSurvey;
